import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root',
})

export class PosSoldItemSearchservice {
  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;
  }

  getDistinctUsersAndTerminals(fromDate: string, toDate: string): Observable<{ Users: string[]; Terminals: string[] }> {
    const params = new HttpParams()
      .set('fromDate', fromDate)
      .set('toDate', toDate);

    return this.http.get<{ Users: string[]; Terminals: string[] }>(
      `${this.baseURL}/POSSoldItemSearch/GetDistinctUsersAndTerminals`,
      { params }
    );
  }

  getSoldItemList(
    fromDate: string,
    toDate: string,
    options?: {
      vendorId?: number | string | null;
      itemSearch?: string;
      priceSearch?: string;
      searchByItemName?: string;       
      searchWholeWordOnly?: boolean;
      showAllSoldItems?: boolean;
      terminal?: string | null;
      user?: string | null;
    },
    pageNumber: number = 0,
    pageSize: number = 100
  ): Observable<{ Result: any[]; Count: number }> {

    const raw: any = {
      fromDate,
      toDate,
      vendorId: options?.vendorId,
      itemSearch: options?.itemSearch,
      priceSearch: options?.priceSearch,
      searchByItemName: options?.searchByItemName,
      searchWholeWordOnly: options?.searchWholeWordOnly ?? false,
      showAllSoldItems: options?.showAllSoldItems ?? false,
      terminal: options?.terminal,
      user: options?.user,
      pageNumber,
      pageSize
    };

    const params: any = {};
    Object.keys(raw).forEach(key => {
      const value = raw[key];
      if (value !== null && value !== undefined && value !== '') {
        params[key] = value;
      }
    });

    return this.http
      .get<{ Result: any[]; Count: number }>(
        `${this.baseURL}/POSSoldItemSearch/GetSoldItemList`,
        { params, observe: 'response' }
      )
      .pipe(
        map((res: HttpResponse<{ Result: any[]; Count: number }>) => res.body),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}  